// extracted by mini-css-extract-plugin
export var light = "unordered-list-module--light--06bd0";
export var ul = "unordered-list-module--ul--1f683";